export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_05.9b955b9d.jpg";